// ONE query for the org's own subscription, shared by the app-shell banner,
// the dashboard usage card and the Subscription page: same key means one
// request, one cache entry, and a single invalidation point after cancel/
// payment changes. GET /billing/subscription is org_admin-only, so callers
// that can run for other roles must pass `enabled: false`.

import { getSubscription } from '@jq4race/api-client';
import { useQuery } from '@tanstack/react-query';

export const OWN_SUBSCRIPTION_QUERY_KEY = ['subscription', 'own'] as const;

/** Prefix covering the subscription, its invoices and its overage charges. */
export const SUBSCRIPTION_QUERY_PREFIX = ['subscription'] as const;

export function useOwnSubscription({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: OWN_SUBSCRIPTION_QUERY_KEY,
    queryFn: () => getSubscription(),
    enabled,
    // Short enough that a payment recorded by super_admin shows up on the
    // next navigation/focus, long enough not to refetch per route.
    staleTime: 60_000,
  });
}
